// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconFooterPtda: React.FC<{ width?: number; height?: number }> = ({ width = 44, height = 24 }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height}>
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M1.848 14.97h7.091c2.435 0 3.11 1.136 2.692 3.15-.352 1.734-1.504 3.07-3.946 3.07H4.011l-.572 2.803H0zm10.619 0h9.79l-.462 2.272h-3.183l-1.379 6.75h-3.439l1.386-6.75h-3.183zm-5.398 2.124H4.855l-.389 1.897h2.215c.865 0 1.254-.28 1.386-.937.139-.687-.132-.96-.998-.96m30.34 4.39.138-.251 2.682 1.907.012.086zm-4.004-2.461q.057-.357.08-.68l.857.61.79.562-.255.413zm-.332-2.796 2.583 2.435-.304.495-1.862-1.493c-.034-.583-.174-1.058-.417-1.437m5.036 3.983 2.057 2.48.021.152-2.225-2.365zm1.363-2.479.671 4.796-1.888-2.583zm.745 5.327-2.55-2.045.165-.299 2.37 2.236zm-10.48-3.573c-.294 1.424-1.093 2.235-2.662 2.235h-1.973l.917-4.47h1.972c1.57 0 2.039.803 1.746 2.235m10.611 4.508H44l-1.855-9.023h-4.217l-1.512 2.457-8.168-11.178-.33 1.675 8.236 9.929-.261.424L18.7 0l-.44 2.258L32.292 15.49c-.544-.315-1.265-.475-2.152-.512L11.697.192l-.47 2.316L28.742 14.97h-1.928l-9.91-6.095-.353 1.66 8.24 4.435H23.05L21.2 24h6.761c2.869 0 4.681-1.324 5.346-4.448l1.353.728-2.284 3.713h3.652l1.263-2.297 2.957 1.59z"
            />
        </svg>
    );
};

export default React.memo(IconFooterPtda);
